import {dedupePanelChanges, formatToggleLabel, isEnabledToggleChange, readToggleState} from './panelChangeLog';

const normalizeEntity = entity => String(entity || '').toLowerCase();

const isAdUnitEntityChange = change => normalizeEntity(change.entity) === 'adunit';

const isEnabledToggle = isEnabledToggleChange;

/** One summary card / setting (e.g. Price adjustments · Adagio, Smart ad refresh · Enabled). */
export const buildSettingKey = change => {
  const entity = normalizeEntity(change.entity);
  const attGroup = change.attGroupName || '';

  if (isAdUnitEntityChange(change)) {
    return [entity, 'adunit', change.entityColumn || ''].join('|');
  }

  if (isEnabledToggle(change)) {
    const label = formatToggleLabel(readToggleState(change.entityValue) || 'enabled') || 'Enabled';
    return [entity, attGroup, 'enabled', label].join('|');
  }

  const attName = change.attName || change.entityColumn || '';
  return [entity, attGroup, attName].join('|');
};

/** Count distinct settings after deduping fan-out log rows. */
export const countSettingsForChanges = changes => {
  const uniqueChanges = dedupePanelChanges(changes);
  if (uniqueChanges.length === 0) return 0;

  const keys = new Set();
  for (const change of uniqueChanges) {
    keys.add(buildSettingKey(change));
  }
  return keys.size;
};

export const buildSettingCountsByDate = changesByDate => {
  if (!changesByDate) return {};
  const counts = {};
  for (const [date, changes] of Object.entries(changesByDate)) {
    counts[date] = countSettingsForChanges(changes);
  }
  return counts;
};
